/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import deleteRegionalProjectActions, {
    deleteRegionalProjectTypes,
} from '../../../../redux/donneesSocioEconomique/donneesRegionalProject/deleteRegionalProject'
import getRegionalProjectActions from '../../../../redux/donneesSocioEconomique/donneesRegionalProject/getRegionalProject'
import { Delete } from '../../../../serveur/axios'

function* deleteRegionalProjectSagas({ response }) {
    try {
        const responseDelete = yield Delete(`regional-project/${response.id}`)
        if (responseDelete.status === 200 || responseDelete.status === 201) {
            yield all([
                yield put(
                    deleteRegionalProjectActions.deleteRegionalProjectSuccess(
                        responseDelete.data
                    )
                ),
                yield put(
                    getRegionalProjectActions.getRegionalProjectRequest()
                ),
            ])
        } else {
            yield put(
                deleteRegionalProjectActions.deleteRegionalProjectFailure(
                    responseDelete.data
                )
            )
        }
    } catch (error) {
        yield put(
            deleteRegionalProjectActions.deleteRegionalProjectFailure(error)
        )
    }
}

export function* deleteRegionalProjectSaga() {
    yield takeLatest(
        deleteRegionalProjectTypes.DELETE_REGIONAL_PROJECT_REQUEST,
        deleteRegionalProjectSagas
    )
}
